import { render, staticRenderFns } from "./PromoterOrder.vue?vue&type=template&id=abb30e6e"
import script from "./PromoterOrder.vue?vue&type=script&lang=js"
export * from "./PromoterOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports